type PipelineEntitySummaryQueryGateInput = {
  hasOnlyNoBuildsSelected: boolean;
  isAuthenticated: boolean;
  runSummarySettled: boolean;
};

type PipelineSecondaryQueryGateInput = {
  currentSummaryLoading: boolean;
  hasCurrentSummary: boolean;
  isAuthenticated: boolean;
};

type PipelineOptionsQueryGateInput = {
  dailyHistorySettled: boolean;
  secondaryQueriesEnabled: boolean;
};

export const shouldLoadPipelineEntitySummaryQuery = ({
  hasOnlyNoBuildsSelected,
  isAuthenticated,
  runSummarySettled,
}: PipelineEntitySummaryQueryGateInput): boolean =>
  isAuthenticated && (hasOnlyNoBuildsSelected || runSummarySettled);

export const shouldLoadPipelineSecondaryQueries = ({
  currentSummaryLoading,
  hasCurrentSummary,
  isAuthenticated,
}: PipelineSecondaryQueryGateInput): boolean =>
  isAuthenticated && (!currentSummaryLoading || hasCurrentSummary);

export const shouldLoadPipelineOptionsQuery = ({
  dailyHistorySettled,
  secondaryQueriesEnabled,
}: PipelineOptionsQueryGateInput): boolean => secondaryQueriesEnabled && dailyHistorySettled;
